<script lang="ts" generics="T extends string">
  import { Tabs as BitsTabs } from 'bits-ui';
  import type { Snippet } from 'svelte';

  let {
    value = $bindable(),
    items,
    label,
    align = 'start',
    disabled = false,
    onchange,
    children,
  }: {
    value: T;
    items: readonly { value: T; label: string }[];
    label: string;
    align?: 'start' | 'center';
    disabled?: boolean;
    onchange?: (value: T) => void;
    children: Snippet<[value: T]>;
  } = $props();

  function select(next: string): void {
    value = next as T;
    onchange?.(value);
  }
</script>

<BitsTabs.Root class="tabs-root" {value} onValueChange={select} activationMode="manual" {disabled}>
  <BitsTabs.List class={align === 'center' ? 'tabs-list centered' : 'tabs-list'} aria-label={label}>
    {#each items as item (item.value)}
      <BitsTabs.Trigger class="btn small tabs-trigger" value={item.value} {disabled}
        >{item.label}</BitsTabs.Trigger
      >
    {/each}
  </BitsTabs.List>
  {#each items as item (item.value)}
    <BitsTabs.Content class="tab-panel" value={item.value}>
      {#if value === item.value}
        {@render children(item.value)}
      {/if}
    </BitsTabs.Content>
  {/each}
</BitsTabs.Root>

<style>
  :global(.tabs-root),
  :global(.tab-panel:not([hidden])) {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }
  :global(.tabs-list) {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
  }
  :global(.tabs-list.centered) {
    justify-content: center;
  }
  :global(.tabs-trigger[data-state='active']) {
    --button-hover-texture: none;
    --button-hover-background: var(--theme-selected);
    --button-hover-text: var(--theme-selected-text);
    background: var(--theme-selected);
    color: var(--theme-selected-text);
  }
  :global(.tab-panel:focus-visible) {
    outline: var(--theme-focus-width) solid var(--theme-focus);
    outline-offset: 2px;
  }
</style>
